module.exports = __webpack_public_path__ + "img/line_castle.11d95668.png";